// @flow
import React, { Component } from 'react';
import uuid from 'uuid/v1';
import { Wrapper } from './style';

type Props = {
  label: string,
  value: boolean,
  onClick: (checked: boolean) => void
};

class Checkbox extends Component<Props> {
  handleClick = (event: { target: { checked: boolean } }) => {
    const { onClick } = this.props;

    onClick(event.target.checked);
  };

  render() {
    const { label, value } = this.props;

    const id = uuid();

    return (
      <Wrapper>
        <div className="checkbox-container">
          <label htmlFor={id} className="label--checkbox">
            <input
              type="checkbox"
              id={id}
              className="checkbox"
              checked={value}
              onClick={this.handleClick}
              readOnly
            />
            <div>{label}</div>
          </label>
        </div>
      </Wrapper>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js